import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import CustomDropdown from 'molecules/CustomDropdown/Container/CustomDropdown';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { parseDateList } from '../ScheduleOrderUtils/ScheduleOrderUtils';
import InlineErrors from 'organisms/SearchStore/AU/Presentation/InlineErrors';
import ImageComponent from 'atoms/Image';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
const DateTimeSectionComp = props => {
  const {
    show,
    sectionHeader,
    selectedDate,
    selectedTime,
    changeDateValue,
    changeTimeValue,
    dateTimeArr,
    dateTimeArrWithOrderCapacity,
    showCateringWarning = false,
    scheduleTimeWarning = false,
    scheduleErrMsg = '',
    scheduleErrorType = '',
    scheduleWarningMsg = '',
    changeTimeObj = {},
    changeDateObj = {},
    placeholderText,
    disableDateOption = false,
    disableTimeOption = false,
    enableScheduleOrderFlag = false,
    enableOrderCapacityManagement = false,
  } = props;
  const { SingleArrow } = IMAGE_PATH;
  const { DATE, TIME } = TRANSLATE_MAPPING_KEY;
  const dateTimeSectionClassName = enableScheduleOrderFlag
    ? 'date-time-section date-time-section-ca'
    : 'date-time-section date-time-section-au';
  const selectedDateTimeArray = enableOrderCapacityManagement ? dateTimeArrWithOrderCapacity : dateTimeArr;
  return show ? (
    <div className='schedule-order-form-sections'>
      <h3 className='schedule-form-subsection-header'>{translateWithI18Next(sectionHeader)}</h3>
      <InlineErrors
        show={showCateringWarning?.show}
        errorMsg={showCateringWarning?.warning}
        errImage={showCateringWarning?.image}
        cssClass={showCateringWarning?.cssClass}
      />
      {scheduleTimeWarning && (
        <div className='store-cannot-schedule-error timebased-inline-message'>
          <ImageComponent srcFile={IMAGE_PATH.Error} className='store-cannot-deliver-icon' />
          <div className='storeErrorMessage'>{scheduleErrMsg}</div>
        </div>
      )}
      <div className={dateTimeSectionClassName}>
        <CustomDropdown
          cssClass='date-time-dropdown'
          dropdownTitle={translateWithI18Next(DATE)}
          setSelectedItem={changeDateValue}
          changeDateObj={changeDateObj}
          changeTimeObj={changeTimeObj}
          dateTimeArr={selectedDateTimeArray || dateTimeArr}
          selectedItem={selectedDate?.date}
          imgSrc={SingleArrow}
          options={parseDateList(selectedDateTimeArray || dateTimeArr)}
          dropdownId={'date-id'}
          disableOptions={disableDateOption}
          shouldDisplayDropdownError={
            scheduleTimeWarning &&
            scheduleWarningMsg &&
            scheduleErrorType === START_ORDER_CONSTANTS.ORDER_CAPACITY_DAY_ERROR
          }
          errorMessage={scheduleWarningMsg}
        />

        <CustomDropdown
          cssClass={`date-time-dropdown ${enableOrderCapacityManagement ? 'date-time-dropdown--order-capacity' : ''}`}
          dropdownTitle={translateWithI18Next(TIME)}
          setSelectedItem={changeTimeValue}
          changeDateObj={changeDateObj}
          changeTimeObj={changeTimeObj}
          dateTimeArr={selectedDateTimeArray || dateTimeArr}
          selectedItem={selectedTime}
          imgSrc={SingleArrow}
          options={selectedDate?.timeSlots}
          dropdownId={'time-id'}
          placeholderText={placeholderText}
          disableOptions={disableTimeOption}
          enableOrderCapacityManagement={enableOrderCapacityManagement}
          shouldDisplayDropdownError={
            scheduleTimeWarning &&
            scheduleWarningMsg &&
            scheduleErrorType === START_ORDER_CONSTANTS.ORDER_CAPACITY_TIME_ERROR
          }
          errorMessage={scheduleWarningMsg}
        />
      </div>
    </div>
  ) : null;
};

const DateTimeSection = React.memo(DateTimeSectionComp);
export default DateTimeSection;
